module.exports = __webpack_public_path__ + "27bd77b9162d388cb8d4c4217c7c5e2a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/lato/Lato.woff
// module id = 592
// module chunks = 0